import { createContext, useContext, useEffect, useLayoutEffect, useState } from "react";

const SiteUiContext = createContext(null);
export const MOBILE_QUERY = "(max-width: 767px), (max-width: 1023px) and (max-height: 500px)";

export function SiteUiProvider({ children }) {
  const [chatOpen, setChatOpen] = useState(false);
  const [modalCount, setModalCount] = useState(0);
  const [mobile, setMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);
  const [editing, setEditing] = useState(false);
  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    const viewport = window.visualViewport;
    let frame;
    const revealFocusedField = () => {
      const active = document.activeElement;
      const scroll = active?.closest(".booking-dialog-scroll");
      if (!media.matches || !scroll || !active.matches("input, textarea, select")) return;
      const rect = active.getBoundingClientRect();
      const area = scroll.getBoundingClientRect();
      const top = Math.max(area.top, viewport?.offsetTop || 0) + 12;
      const bottom = Math.min(area.bottom, (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight)) - 12;
      if (rect.bottom > bottom) scroll.scrollTop += rect.bottom - bottom;
      else if (rect.top < top) scroll.scrollTop -= top - rect.top;
    };
    const update = () => {
      setMobile(media.matches);
      document.documentElement.style.setProperty("--ptg-visible-height", `${viewport?.height || window.innerHeight}px`);
      document.documentElement.style.setProperty("--ptg-viewport-top", `${viewport?.offsetTop || 0}px`);
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => { frame = requestAnimationFrame(revealFocusedField); });
    };
    const focus = () => {
      setEditing(!!document.activeElement?.matches('input:not([type="checkbox"]):not([type="radio"]), textarea, select'));
      update();
    };
    update();
    media.addEventListener("change", update);
    window.addEventListener("resize", update);
    viewport?.addEventListener("resize", update);
    viewport?.addEventListener("scroll", update);
    document.addEventListener("focusin", focus);
    document.addEventListener("focusout", focus);
    return () => {
      cancelAnimationFrame(frame);
      media.removeEventListener("change", update);
      window.removeEventListener("resize", update);
      viewport?.removeEventListener("resize", update);
      viewport?.removeEventListener("scroll", update);
      document.removeEventListener("focusin", focus);
      document.removeEventListener("focusout", focus);
    };
  }, []);
  return <SiteUiContext.Provider value={{ chatOpen, setChatOpen, modalCount, setModalCount, mobile, editing }}>{children}</SiteUiContext.Provider>;
}

export const useSiteUi = () => useContext(SiteUiContext);

export const SiteOverlayMarker = () => {
  const { setModalCount } = useSiteUi();
  useLayoutEffect(() => {
    setModalCount((n) => n + 1);
    return () => setModalCount((n) => n - 1);
  }, [setModalCount]);
  return null;
};
